export default "__VITE_ASSET__6PQM_tEY__"